import $ from "jquery";
export const getShapeBackgroundColor = (id: string) =>
  $(`#shape-shape-${id}`).attr("fill");
export const setShapeBackgroundColor = (id: string, value: string) =>
  $(`#shape-shape-${id}`).attr("fill", `${value}`);
